import React from 'react'
import { Field, FieldArray } from 'formik';
import Icon from "../../../components/Icon/Icon";
import styled from 'styled-components';
import Button from '../../../components/Button/Button';
import { sortableContainer, sortableElement, sortableHandle } from 'react-sortable-hoc';

const DragHandle = sortableHandle(() => <Icon name="drag" label="Drag" inline style={{ cursor: 'pointer' }}/>);
const Label = styled.label`
  display: inline-block;
  margin: ${({ margin }) => margin };
`;
const Trash = styled(Icon)`
  margin-left: 10px;
`;

const AddButton = styled(Icon)`
display: inline-block;
vertical-align: -6px;
`

const SortableItem = sortableElement(({ value, i, isLast }) => {
  return (<FieldArray name="credits.fields" render={
        arrayHelpers => (
        <div className="margin--top" key={i}>
          <Label margin="0 10px 0 0" >Label</Label>
          <Field name={`credits.fields.${i}.label`}/>
          <Label margin="0 10px 0 20px">Value</Label>
          <Field name={`credits.fields.${i}.value`} style={{ width: '400px' }} />
          <Trash clickable key={ i } name="trash" onClick={() => { arrayHelpers.remove(i) }} label="Remove" inline />
          <DragHandle />
          { isLast && <AddButton name="add" onClick={ () => { arrayHelpers.push({ label: '', value: ''})} } /> }
        </div>)
      } />
  )
});

const SortableContainer = sortableContainer(({children}) => {
  return <div>{children}</div>;
});

class FormCreditField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: this.props.values
          && this.props.values.credits
          && this.props.values.credits.fields
          && this.props.values.credits.fields.length > 0
          && this.props.values.credits.fields || []
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.values.credits.fields !== prevProps.values.credits.fields) {
      this.setState({
        items: this.props.values
            && this.props.values.credits
            && this.props.values.credits.fields
            && this.props.values.credits.fields.length > 0
            && this.props.values.credits.fields || []
      })
    }
  }

  onSort = (data, arrayHelpers) => {
    arrayHelpers.swap(data.oldIndex, data.newIndex)
  };

  render() {
    const { items } = this.state;
    return (
      <FieldArray name="credits.fields" render={ arrayHelpers =>
          <SortableContainer onSortEnd={ (data) => this.onSort(data, arrayHelpers) } useDragHandle>
            <div>
            { items.map((value, index) =>
                <SortableItem key={`item-${index}`} i={ index } isLast={ items.length === index +1} index={index} value={value} />
            )}
            </div>
          </SortableContainer> }
      />);
  }
}

export default FormCreditField



// WEBPACK FOOTER //
// ./src/containers/add/Credits/FormCreditFields.js